const { createContext } = require("react");

const SharedItemsDashboardContext = createContext(null);

export default SharedItemsDashboardContext;